import React from 'react';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import {makeStyles} from "@material-ui/core/styles";


const useStyles = makeStyles(theme => ({
    textarea: {
        width: '100%',
        border: 'none',
        borderRadius: 8,
        backgroundColor: 'white',
        padding: 32,
    }
}));


export default function TextArea(props) {

    const classes = useStyles();

    return (
        <TextareaAutosize {...props} className={`${classes.textarea} ${props.className}`} />
    )
}